import { render, staticRenderFns } from "./PostInfo.vue?vue&type=template&id=c85ac4ba&scoped=true&"
import script from "./PostInfo.vue?vue&type=script&lang=ts&"
export * from "./PostInfo.vue?vue&type=script&lang=ts&"
import style0 from "./PostInfo.vue?vue&type=style&index=0&id=c85ac4ba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c85ac4ba",
  null
  
)

export default component.exports